
import {
    OBSERVACIO_FORMULARI_OBTENIR_DATA_HORA,
    OBSERVACIO_FORMULARI_MODIFICAR_DATA_HORA,
    OBSERVACIO_INICIALITZAR,
    OBSERVACIO_FORMULARI_INICIALITZAR
} from '../../../actions/actionTypes';

const ESTAT_INICIAL_HORA_OBSERVACIO_FORMULARI = {};

const horaObservacio = (state = ESTAT_INICIAL_HORA_OBSERVACIO_FORMULARI, action) => {

    switch (action.type) {
        case OBSERVACIO_FORMULARI_OBTENIR_DATA_HORA:
            return {dataHoraObservacio: action.dataHoraObservacio};
        case OBSERVACIO_FORMULARI_MODIFICAR_DATA_HORA:
            return {
                ...state,
                dataHoraObservacioNou: action.dataHoraObservacioNou
            };
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_HORA_OBSERVACIO_FORMULARI;
        case OBSERVACIO_FORMULARI_INICIALITZAR:
            return ESTAT_INICIAL_HORA_OBSERVACIO_FORMULARI;
        default:
            return state;
    }
};

export default horaObservacio;



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/dataHoraObservacio.js